import React, { useContext, useEffect, useMemo } from 'react';
import StoreCategoryView from '../StoreCategoryView/StoreCategoryView';
import { t } from '../../../../common/components/T';
import { LangContext } from '../../../../common/decorators/Language';
import Store from '../../../../layouts/store/Store/Store';
import Skeleton from '../../../../widgets/plug/Skeleton/Skeleton';
import { categoriesSkeleton } from '../../initData';
import css from './StoreCategoryWrapper.module.scss';
import { replaceUrl } from '../../../../common/utils/router';
import { useRouter } from 'next/router';
import HelpComponent from '../components/HelpComponent/HelpComponent';
import UserContext, { UserProfileContext } from '../../../../common/utils/getContext';
import { combineData } from '../../../../common/utils/utils';
import { getMemoizedData } from '../../../../common/utils/memo';

const RenderData = (props) => {
    const {
        subCategories,
        loaded,
        product,
        category,
        qSearch,
        isLoadingPrice,
        setInitDataProduct,
        setLoadingPrice,
        propertiesFilters
    } = props;

    const { storageLoaded, userToken, lang, localization } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);

    useEffect(() => {
        if (!storageLoaded || (userToken && !profileData?.country)) return;
        setLoadingPrice(true);
        if (category?.data) {
            const country_id = profileData?.country?.geoname_id;

            getMemoizedData(
                `/api/v1/shop/products?filter[${category.data?.product_count ? 'categories' : 'category_descendants'}]=${
                    category.data.id
                }&sort=price&page[size]=1000&include=media,special_statuses${
                    country_id ? `&filter[country_id]=${country_id}` : ''
                }`,
                userToken,
                lang,
                profileData?.currency?.code || localization.currency
            ).then((data) => {
                setInitDataProduct({
                    data: combineData([], data?.data)
                });
                setLoadingPrice(false);
            });
        } else if (localization.currency) {
            setLoadingPrice(false);
        }
    }, [localization, lang, category, userToken, profileData]);

    return (
        <Skeleton
            wait={loaded}
            wrapperStyles={{
                className: css.storeWrapperMobileWhite,
                borderRadius: '20px',
                padding: '1.5rem',
                marginTop: '1.5rem',
                marginBottom: '1.5rem',
                background: 'var(--whiteColor)'
            }}
            elements={categoriesSkeleton}
            Component={StoreCategoryView}
            componentProps={{
                category,
                qSearch,
                subCategoriesData: subCategories,
                product,
                propertiesFilters,
                isLoadingPrice
            }}
        />
    );
};

const StoreCategoryWrapper = ({
    loaded,
    subCategories,
    category,
    product,
    categories,
    translates,
    qSearch,
    loadMoreCategories,
    propertiesFilters,
    isLoadingPrice,
    setInitDataProduct,
    setLoadingPrice
}) => {
    const { translation } = useContext(LangContext) || {};
    const breadcrumbs = useMemo(
        () => [
            {
                title: t('mainPageTitle', 'Главная', 'all', translation),
                link: `/`
            },
            {
                title: t('storePageTitle', 'Магазин', 'all', translation),
                link: '/store'
            },
            ...(category?.data?.breadcrumbs?.map((c) => ({
                title: c.name,
                link: `/store/category/${c.url || c.id}`
            })) || []),
            ...(category?.data?.name
                ? [
                      {
                          title: category?.data?.name,
                          link: `/store/category/${category?.data?.url || category?.data?.id}`
                      }
                  ]
                : [])
        ],
        [category?.data, translation]
    );
    const router = useRouter();
    return (
        <Store
            seoData={{
                seo_title: category?.data?.seo_title || category?.data?.name,
                seo_description: category?.data?.seo_description,
                seo_keywords: category?.data?.seo_keywords,
                seo_image: category?.data?.seo_image || category?.data?.image
            }}
            canonical={replaceUrl(`/store/category/${category?.data?.seo_url || `${category?.data?.url}`}`, router)}
            categories={categories}
            loadMoreCategories={loadMoreCategories}
            breadcrumbs={breadcrumbs}
            showBreadcrumbs={true}
            qSearch={qSearch}
            translates={translates}
            title={category?.data?.name || t('storeSearchResults', 'Результаты поиска', '/store', translation)}
            compStyles={css}
            OverFooter={HelpComponent}
        >
            <RenderData
                category={category}
                setLoadingPrice={setLoadingPrice}
                setInitDataProduct={setInitDataProduct}
                loaded={loaded}
                product={product}
                propertiesFilters={propertiesFilters}
                subCategories={subCategories}
                isLoadingPrice={isLoadingPrice}
            />
        </Store>
    );
};
export default StoreCategoryWrapper;
